import React, { useEffect, useState } from 'react';
import {
    Typography,
    Dialog, Box, styled, IconButton, Select, MenuItem, useTheme
} from '@mui/material';
import { makeStyles } from '@mui/styles'
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
// import { deviceDetect, mobileModel } from "react-device-detect"

import { CustomNativeCamera, UseImage, GenericDialog, Buttons, GenericContainerForm, CustomCameraSelfie } from "./";
import { blobToBase64 } from "../utils";
import { HelpDialog } from '../pages/IdentityValidation/HelpDialog'
import { SignalCellularNullOutlined } from '@mui/icons-material';
import maskCaptureDocument from '../assets/maskCaptureDocument.png'
import Comprobante_domicilio from '../assets/Comprobante_domicilio.png';
import { useTranslation } from 'react-i18next';
import mask from "../assets/maskCaptureBlanca.png";
import maskMovil from "../assets/movil/maskMovilBlanca.png";

const ContainerCamera = styled(Box)(({ theme }) => ({
    background: "#FFFFFF",
    margin: "0px",
    marginBottom: '0px',
    [theme.breakpoints.down("sm")]: {
        minHeight: '90vh',
    },
    //overflowY: 'hidden !important',
}));

const useStyles = makeStyles((theme) => ({
    imgPreview: {
        //height: '97vh',
       // marginBottom: '15%', //marginBottom: '13%',
        //paddingBottom: '3%',
        [theme.breakpoints.only('xs')]: {
            //height: '45vh',
            marginBottom: 0,
            paddingBottom: 0,
           // height: "420px",
           // minWidth: "700px!important",
            height: "510px!important",
            minWidth: "700px!important",
        },
        /* [theme.breakpoints.only('xl')]: {
            marginBottom: '15%',
            paddingBottom: '5%',
        }, */
    },
    camara: {
        position: "relative",
        zIndex: 2,
        //height: 460,
        // height: 480, 
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        /* [theme.breakpoints.only('md')]: {
          height: 460,
        },
        [theme.breakpoints.only('lg')]: {
          height: 480,
        },
        [theme.breakpoints.only('xl')]: {
          height: 630,
        }, */
      },
      camaraMovil: {
        position: "relative",
        zIndex: 2,
        height: 'calc(100vh - 100px)',
        //marginTop: '20%',
        ['@media only screen and (max-width: 812px)']: {
          //marginTop: '13%',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          //top: '-17px',
          //height: 480, 
        },
        // height: '100vh',
        
      },
    carouselSection1: {
        marginTop: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            height: '30vh',
            marginTop: '40px',
        },
    },
    '&:hover': {
        outline: 'none',
    },
    '&:active': {
        outline: 'none',
    },
    '&:focus': {
        outline: 'none',
    },
    imgHelp: { //Help
        height: '45vh',
        [theme.breakpoints.only('xs')]: {
            height: '21vh',
        }
    },
    mascaraMovil: {
        position: "absolute",
        zIndex: 3,
        height: '95vh',
        width: "100%",
      },
    mascara: {
        position: "absolute",
        zIndex: 3,
        height: '85vh',
        minWidth: "1000px",
    },
    imagenMovil: {
        height: "90%",
        width: "100%",
    },
    imagen: {
        width: "100%",
        height: "100%",
    },
}))

export const FullCameraCapture = props => {
    const theme = useTheme()
    const localStyles = useStyles();
    // const selectDeviceCurrent = React.useRef(undefined);

    const [initCamera, setInitCamera] = useState(false)
    const [photoTaken, setPhotoTaken] = useState(false)
    const [photoPreview, setPhotoPreview] = useState(null)
    // const [showButtonHideOverlay, setShowButtonHideOverlay] = useState(true)
    // const [deviceId, setDeviceId] = React.useState(null);
    // const [devices, setDevices] = React.useState([]);

    const [controlCameraCustom, setControlCameraCustom] = useState(null)
    const [showHelp, setShowHelp] = useState(true);
    // const [numberOfCameras, setNumberOfCameras] = useState(0);
    // const [selectCameraInit, setSelectCameraInit] = useState(false)
    const isMobile = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) ? true : false
    const { t } = useTranslation();

    useEffect(() => {
        setPhotoPreview(null)
        setControlCameraCustom(null)
        // console.log("photoPreview init control: ", photoPreview)
        // try {
        //     console.log("devicedata deviceDetect: ", deviceDetect()) // gives object shown in image below
        //     console.log("devicedata browserName: ", mobileModel) // gives "iphone"
        // } catch (ex) {
        //     console.log("Constructor Error: ", ex)
        // }
    }, [])

    // if (navigator.mediaDevices === undefined) {
    //     navigator.mediaDevices = {};
    //     // console.log("*******undefined navigator.mediaDevices:******** ", navigator.mediaDevices)
    // }

    // useEffect(() => {
    //     // console.log("**********deviceId, devices.length**********: ", deviceId, devices.length)
    //     if (deviceId?.length > 0 && selectDeviceCurrent === undefined && selectDeviceCurrent === null) {
    //         selectDeviceCurrent.current.click()
    //     }
    // }, [deviceId, selectDeviceCurrent])

    // useEffect(() => {
    //     getDevices().then(gotDevices);
    // }, []);

    useEffect(() => {
        // console.log("**********deviceId, devices.length**********: ", deviceId, devices.length, photoPreview)
        // if ((deviceId != null && devices.length > 0) || !photoPreview || photoPreview) {
        // if ((deviceId != null || devices.length > 0) && (photoPreview || photoPreview == null)) {
        // console.log("photoPreview gnerate control camera: ", photoPreview)
        if (photoPreview || photoPreview === null) {
            setControlCameraCustom(isMobile && props?.isSelfie ? 
            <CustomCameraSelfie
                isDisplay={!photoTaken && photoPreview === null}
                Redimensionar={true}
                onCapture={blob => {
                    setPhotoPreview(blob)
                }}
                CaptureInit={photoTaken} />  
            : <CustomNativeCamera FacingMode="environment"
                isDisplay={photoPreview === null ? true : false}
                Mirrored={false}
                width={navigator.userAgent.match(/iPhone/i) ||
                    navigator.userAgent.match(/Android/i) ? 700 : 1100}
                onCapture={blob => {
                    setPhotoPreview(blob)
                }}
                // deviceId={deviceId}
                CaptureInit={photoTaken} />)
        }
    }, [showHelp, photoTaken])
    // }, [deviceId, devices, showHelp, photoTaken])

    // useEffect(() => {
    //     if (devices?.length > 0) {
    //         try {
    //             if (devices?.length > 1 && mobileModel == "moto e20") {
    //                 let diviceFindSelect = devices?.find((item) => item.label == "camera2 1, facing back")
    //                 if (diviceFindSelect.label != "") {
    //                     // console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
    //                     setDeviceId(diviceFindSelect.deviceId)
    //                 } else {
    //                     setDeviceId(devices[devices.length - 2].deviceId)
    //                 }
    //             }
    //             else if (devices?.length > 1 && mobileModel == "YAL-L21") {
    //                 let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back")
    //                 if (diviceFindSelect.label != "") {
    //                     // console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
    //                     setDeviceId(diviceFindSelect.deviceId)
    //                 } else {
    //                     setDeviceId(devices[devices.length - 1].deviceId)
    //                 }
    //             }
    //             else if (devices?.length > 1) {
    //                 let diviceFindSelect = devices?.find((item) => item.label == "camera2 0, facing back")
    //                 if (diviceFindSelect.label != "") {
    //                     // console.log("idCurrent:, mobileModel: ", diviceFindSelect.deviceId, mobileModel)
    //                     setDeviceId(diviceFindSelect.deviceId)
    //                 } else {
    //                     setDeviceId(devices[devices.length - 1].deviceId)
    //                 }
    //             } else {
    //                 setDeviceId(devices[devices.length - 1].deviceId)
    //             }
    //         } catch (ex) {
    //             setDeviceId(devices[devices.length - 1].deviceId)
    //         }
    //     }
    // }, [devices])

    // let getDevices = () => {
    //     // AFAICT in Safari this only gets default devices until gUM is called :/
    //     return navigator.mediaDevices.enumerateDevices();
    // }

    // let gotDevices = (deviceInfos) => {
    //     window.deviceInfos = deviceInfos; // make available to console
    //     // console.log('Available input and output devices:', deviceInfos);
    //     if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i)) {
    //         let camerasBack = deviceInfos.filter(({ kind, label }) => kind == "videoinput")
    //         // && ((label || '').includes('back') || label === ''))
    //         // console.log("camerasBack******: ", camerasBack)
    //         setDevices(camerasBack)
    //     } else {
    //         setDevices(deviceInfos)
    //     }
    // }

    // let handleChangeCamera = (e) => {
    //     // console.log("e device Id: ", e.target.value)
    //     setDeviceId(e.target.value)
    // }

    return <Dialog fullScreen onClose={props.onClose}
        open={props.open}>
        {/* Mask Container Siempre al Frente */}
        {props.isSelfie ? (
            <Box
                className="mask-container"
                sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 3, mt: 0 }}
            />
        ) : null}
        <ContainerCamera>
            {/* {deviceId != null && devices.length > 1 ?
                <Box sx={{
                    // display: 'flex',
                    display: 'none',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: "center",
                    flexDirection: 'column',
                    alignItems: "center",
                    position: 'fixed',
                    top: 0,
                    backgroundColor: "#FFF",
                    zIndex: 200,
                    height: '7vh',
                    // opacity: '0.5',
                }}>
                    <Typography variant="subtitle2" color="primary" >
                        Si la <b>resolución es baja</b>, cambia de <b>cámara</b>.
                    </Typography>
                    <Select ref={selectDeviceCurrent}
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={deviceId}
                        style={{ color: theme.palette.primary.main }}
                        onChange={handleChangeCamera}
                    >
                        {devices?.map((item, index) => {
                            // return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>{mobileModel}-{item.label}-{item.deviceId}</MenuItem>
                            return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>Cámara {index + 1}</MenuItem>
                            // return <MenuItem style={{ color: theme.palette.primary.main }} value={item.deviceId}>{mobileModel}-{item.label}-Cámara {index + 1}</MenuItem>
                        })
                        }
                    </Select>
                </Box>
                : null} */}
            <Box className={`${isMobile ? localStyles.camaraMovil : localStyles.camara} webcam-wrapper`}
            
             /* sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: "flex-start",
                alignItems: "center",
                height: '100vh',
                mt: {xs: "13vh", md: 0}
            }} */>
                {photoTaken == true && photoPreview != null ? <>
                    {/* {console.log("photoPreview: ", photoPreview)} */}
                    <img
                        className={localStyles.imgPreview} 
                        src={URL.createObjectURL(photoPreview)}
                        alt="experiment" />

                </> : controlCameraCustom}
                {/* {console.log("*****************Devide ID:*****************: ", deviceId)} */}
                {/* {controlCameraCustom} */}
                {/* {console.log("Camara generada: ", controlCameraCustom)} */}
                {(navigator.userAgent.match(/iPhone/i) ||
                    navigator.userAgent.match(/Android/i)) && photoPreview === null ?
                    <Box sx={{
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // border: '2px solid red',
                        backgroundColor: 'transparent !important',
                        //height: '88vh',
                        width: '100%',
                        position: 'absolute',
                        //top: '-10px',
                        zIndex: 10,
                    }}>
                        <UseImage
                            className={localStyles.docIcon}
                            src={maskCaptureDocument}
                            width={100}
                        />
                    </Box> : null}
            </Box>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: "center",
                alignItems: "center",
                //backgroundColor: theme.palette.primary.backG,
                backgroundColor: "#ffff",
                bottom: "0px",
                position: 'sticky',
                paddingBottom: '24px',
                zIndex: 120,
            }}>
                {photoTaken &&
                    <>
                        <IconButton title="Recaptura" color="primary"
                            classes={{ root: localStyles.iconApproval }}
                            style={{ marginRigth: '1em !importat', color: theme.palette.primary.main, }}
                            onClick={() => {
                                setPhotoTaken(false)
                                setPhotoPreview(null)
                            }}>Recaptura&nbsp;
                            <ClearIcon color='primary'
                                style={{
                                    color: theme.palette.primary.main,
                                    width: '35px',
                                    height: '35px'
                                }} />
                        </IconButton>
                        &nbsp;&nbsp;&nbsp;
                        <IconButton title={t("general_accept")} color="primary"
                            classes={{ root: localStyles.iconApproval }}
                            style={{ marginLeft: '1em !importat', color: theme.palette.primary.main, }}
                            onClick={() => {
                                blobToBase64(photoPreview).then(res => {
                                    // console.log("blobToBase64-------- Carga WEB----------", res)
                                    let resultReplace = res.replace('data:image/jpeg;base64,', '')
                                    //   setDocument(resultReplace)
                                    setPhotoTaken(false)
                                    setPhotoPreview(null)
                                    props.onSendData(resultReplace)
                                });
                            }}>{t("general_accept")}&nbsp;
                            <CheckIcon color='primary'
                                style={{
                                    color: theme.palette.primary.main,
                                    width: '35px',
                                    height: '35px'
                                }} />
                        </IconButton>
                    </>
                }
                {!photoTaken && // showButtonHideOverlay && 
                    <>
                        <IconButton title={t("general_cancel")} color="primary"
                            classes={{ root: localStyles.iconButton }}
                            style={{ marginRigth: '1em !importat', color: theme.palette.primary.main, }}
                            onClick={props.onClose}>{t("general_cancel")}&nbsp;
                            <ClearIcon style={{
                                color: theme.palette.primary.main,
                                // backgroundColor: '#1E1E1E',
                                width: '35px',
                                height: '35px'
                            }} />
                        </IconButton>
                        &nbsp;&nbsp;&nbsp;
                        <IconButton title={t("document_capture")} color="primary"
                            classes={{ root: localStyles.iconButton }}
                            style={{ marginLeft: '1em !importat', color: theme.palette.primary.main, }}
                            onClick={() => {
                                setPhotoTaken(true)
                            }}>{t("document_capture")}&nbsp;
                            <PhotoCameraIcon style={{
                                color: theme.palette.primary.main,
                                // backgroundColor: '#1E1E1E',
                                width: '35px',
                                height: '35px'
                            }} />
                        </IconButton>
                    </>
                }
            </Box>
        </ContainerCamera>
        {/* {console.log("props.sectionName***********: ", props.sectionName)} */}
        {showHelp === true && props.sectionName != undefined ?
            <HelpDialog
                open={showHelp}
                closeAction={() => {
                    // setOpenHelps(false)
                    setShowHelp(false)
                    // clearCancelAction()
                }}
                sectionName={props.sectionName}
                DocName={props.DocName}
                capture={props.capture}
                onCapture={() => {
                    setShowHelp(false)
                }}
            />
            : <HelpDialogGeneric
                open={showHelp}
                closeAction={() => {
                    // setOpenHelps(false)
                    setShowHelp(false)
                    // clearCancelAction()
                }}
                sectionName={props.sectionName}
                DocName={props.DocName}
                capture={props.capture}
                onCapture={() => {
                    setShowHelp(false)
                }}
            />}


    </Dialog >
};

export const HelpDialogGeneric = (props) => {
    const localStyles = useStyles()
    // console.log("ppropsropsprops", props)
    const { t } = useTranslation();
    return (
        <GenericDialog open={props.open} onClose={props.closeAction}
            content={<Box sx={{
                display: 'flex',
                position: 'relative',
                flexDirection: 'column',
                alignItems: "center",
            }}>
                <GenericContainerForm sx={(theme) => ({
                    width: "80%", [theme.breakpoints.only('xs')]: {
                        width: "100%"
                    }
                })}>
                    <Typography variant="subtitle1" align='justify' >
                      {t("document_capture_instructions")}
                    </Typography>
                    <Box sx={(theme) => ({
                        width: "100%",
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent:'center', 
                        [theme.breakpoints.only('xs')]: {
                            height: "60vh",
                        },
                        [theme.breakpoints.only('sm')]: {
                            height: "58vh",
                        },
                        [theme.breakpoints.only('md')]: {
                            height: "58vh",
                        },
                        [theme.breakpoints.only('lg')]: {
                            height: "63vh",
                        },
                        [theme.breakpoints.only('xl')]: {
                            height: "68vh",
                        },
                    })}>
                        <UseImage src={Comprobante_domicilio} className={localStyles.imgHelp} />
                    </Box>

                </GenericContainerForm>
            </Box>}
            actions={<Buttons onClickConfirm={props.onCapture}
            />}
        />
    )
}